import { useFormStore } from "../store/formStore";
import { useUserRole } from "./useUserRole";

/**
 * True when the current user should see the read-only review ("Thank You") page
 * instead of the editable wizard.
 *
 * A submitted form is locked for everyone — corrections aren't edited in place;
 * an internal user creates a new draft version via the Salesforce "Edit Intake Form"
 * action, and only that draft is editable. So the form is read-only when:
 *   - it is submitted (locked for both internal and external users), OR
 *   - an external user is viewing a correction (version 2+) they don't own.
 * Internal users edit only the latest *draft* version; external users only ever view
 * once a submission/correction exists, always seeing the latest version (ADO-3440).
 */
export function useReviewMode(): boolean {
  const { isExternal } = useUserRole();
  const formStatus = useFormStore((s) => s.formStatus);
  const formVersion = useFormStore((s) => s.formVersion);
  return formStatus === "submitted" || (isExternal && (formVersion ?? 1) > 1);
}
